module.exports = __webpack_public_path__ + "img/empty_img.418010e4.png";